import React from "react";
import { Slide, Modal } from "@mui/material";

export const SlideUpModal = ({ children, open, onClose }) => (
  <Modal open={open} onClose={onClose} closeAfterTransition>
    <Slide direction="up" in={open} mountOnEnter unmountOnExit>
      <div className="slide-up-modal-content">{children}</div>
    </Slide>
  </Modal>
);
